import type { CropMonitoring } from '/@/types/crop-monitoring';

/** The campaign has at least one yield estimation to show as a registry card. Corn-only. */
export const hasYieldEstimation = (cropMonitoring?: CropMonitoring): boolean =>
    (cropMonitoring?.cornCropMonitoring?.yieldEstimations?.length ?? 0) > 0;

/** The newest estimation on the campaign (the API returns them newest-first). */
export const newestYieldEstimation = (cropMonitoring?: CropMonitoring) =>
    cropMonitoring?.cornCropMonitoring?.yieldEstimations?.[0];

/**
 * Date used to place the yield-estimation card on the timeline: the newest estimation's
 * created date, falling back to the corn expected-maturity date (estimations happen at maturity).
 */
export const yieldEstimationDate = (cropMonitoring?: CropMonitoring): string | null =>
    newestYieldEstimation(cropMonitoring)?.created ??
    cropMonitoring?.cornCropMonitoring?.expectedMaturityDate ??
    cropMonitoring?.plantingDate ??
    null;
